import { useState, useEffect } from 'react';
import { apiClient } from '../../services/api';

interface AdminUnitHierarchyDisplayProps {
  adminCode: string;
  fallbackName: string;
}

export function AdminUnitHierarchyDisplay({ adminCode, fallbackName }: AdminUnitHierarchyDisplayProps) {
  const [displayName, setDisplayName] = useState<string>(fallbackName);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchHierarchy = async () => {
      if (!adminCode || adminCode === fallbackName) {
        // If adminCode is the same as fallbackName, it's likely a legacy entry
        setDisplayName(fallbackName);
        return;
      }

      setIsLoading(true);
      try {
        const response = await apiClient.getAdministrativeUnitHierarchy(adminCode);
        setDisplayName(response.displayName);
      } catch (error) {
        console.error('Failed to fetch hierarchy for', adminCode, error);
        // Fall back to the original name
        setDisplayName(fallbackName);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHierarchy();
  }, [adminCode, fallbackName]);

  if (isLoading) {
    return <span className="text-gray-500">Loading...</span>;
  }

  return <span className="font-medium">{displayName}</span>;
}
